import {
  teamsDarkTheme as fluentTeamsDarkTheme,
  teamsLightTheme as fluentTeamsLightTheme,
} from '@ms/yammer-web-core-ui/dist/util/theme/fluent9';
import { getTheme } from 'domains/teams/selectors';
import { useSelector } from 'hooks/useSelector';

export const useAppHeaderFluentTheme = () => {
  const theme = useSelector(getTheme);

  return theme === 'dark' ? fluentTeamsDarkTheme : fluentTeamsLightTheme;
};
